// extracted by mini-css-extract-plugin
module.exports = {"container":"details_container_gLADD","description":"details_description_2-DiX","lore":"details_lore_1cuLw"};